import { useAtomValue } from "jotai";

import { useInvoicesQuery } from "~/graphql/graphql-new.gen";
import { activeSaleIdState } from "~/stores/sales";

import { applyInvoicesPreview, getBillingPreview } from "./billing-preview";

export const useInvoices = () => {
  const activeSaleId = useAtomValue(activeSaleIdState);
  const preview = getBillingPreview();

  const invoices = useInvoicesQuery(
    {
      saleId: activeSaleId ?? "",
    },
    {
      select: (data) => applyInvoicesPreview(data.invoices, preview),
      staleTime: 1000,
    },
  );

  return invoices;
};
